import React from 'react';
import Hero from './components/Hero';
import RegistrationForm from './components/RegistrationForm';
import InfoSection from './components/InfoSection';

function App() {
  return (
    <div>
      <Hero />
      <RegistrationForm />
      <InfoSection />
    </div>
  );
}

export default App;

